import * as React from "react";

export const SvgNotification = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M16.6 13.707a1.045 1.045 0 0 1-1.044-1.044V8.994a5.502 5.502 0 0 0-3.67-5.181v-.99A1.825 1.825 0 0 0 10.063 1 1.825 1.825 0 0 0 8.24 2.823v.99a5.502 5.502 0 0 0-3.67 5.181v3.67c0 .575-.467 1.043-1.043 1.043a.527.527 0 0 0-.527.527v2.038c0 .291.236.527.527.527h4.534v.199c0 1.104.898 2.002 2.002 2.002a2.005 2.005 0 0 0 2.002-2.002v-.199H16.6a.527.527 0 0 0 .527-.527v-2.038a.527.527 0 0 0-.527-.527ZM9.294 2.823a.769.769 0 0 1 1.536 0v.732a5.515 5.515 0 0 0-1.536 0v-.732Zm1.716 14.175a.949.949 0 0 1-1.895 0v-.199h1.895v.199Zm5.06-1.254H4.056v-1.05a2.102 2.102 0 0 0 1.57-2.03v-3.67a4.443 4.443 0 0 1 4.438-4.438 4.443 4.443 0 0 1 4.438 4.438v3.67c0 .974.668 1.796 1.57 2.03v1.05Z"
			fill={props.color ?? "#A8A8A8"}
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={0.4}
		/>
	</svg>
);
